export default __webpack_public_path__ + "static/crushed-3f0dd1980a0640faef6369e1d7c13089.png";